import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { useUpdateLotMutation } from "../../../newapi/inbound/lots";
import { tokens } from "../../../theme";
import { yupRequired } from "../../../utils/validation";
import SHModal from "../../theme/Modal/SHModal";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ShDateRangePicker from "../../theme/ShDateRangePicker";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import { showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../utils/toasts";
import { toast } from "react-toastify";

const MUpdateLot = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [updateLot, {loading: updateLotLoading, fetching: updateeLotFetching}] = useUpdateLotMutation();

    const [lotInfo, setLotInfo] = useState(props.lot);

    useEffect(() => {
        if(!props.open) {
            setLotInfo({})
        } else {
            setLotInfo(props.lot);
        }
    },[props.open, props.lot])

    const [fieldErrors, setFieldErrors] = useState({});

    const lotValidationSchema = yup.object().shape({
        number: yup.string()
          .required('Number is required'),
        amountReceived: yup.number()
          .typeError('Amount must be a number')
          .required('Amount received is required')
          .positive('Amount must be greater than zero')
          .integer('Amount must be an integer'), 
    });
   
    const UpdateLotAction = async () => {
        if(updateLotLoading) return;
        try {
            setFieldErrors({});
            await lotValidationSchema.validate(lotInfo, { abortEarly: false });
            updateLot(lotInfo).unwrap().then(res => {
                props.handleClose(lotInfo);
                toast.success(t("update_success"), {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }).catch(err => {
                showToastMessageRequestError(t("update_failed"), t, err);

            })
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are fied names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                  ...acc,
                  [currentError.path]: currentError.message
                }), {});
          
                setFieldErrors(errors);
              } else {
                showToastMessageRequestError(t("update_failed"), t, err);
              }
        }
    };
    
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }
    
    return(
        <SHModal
            open={props.open}
            onClose={() => props.handleClose(null)}
        >
            {props.lot !== null && 
            <>
                <Box 
                    sx={{
                        textAlign:"center",
                        paddingY:4,
                        paddingX:5,
                        display:"flex",
                        flexDirection:"column",
                        alignItems:"center",
                        gap:1
                    }}>
                    <Subheading>{t("update_lot")}</Subheading>
                </Box>

                {/* BODY */}
                <Box
                    sx={{
                        background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                        padding:3,
                        borderTopLeftRadius:16,
                        borderTopRightRadius:16,
                        display:"flex",
                        flexDirection:"column",
                        gap:2
                    }}
                >
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:7
                        }}
                    >

                        <Box
                            sx={{
                                width:120,
                                flexShrink:0,
                            }}
                        >
                            <Text light>{t("amount")}</Text>
                        </Box>
                        <ShValidatedInput
                            name="amountReceived"
                            value={lotInfo.amountReceived}
                            onChange={(name,value) => {
                                const input = value;
                                if (/^\d*$/.test(input)) {
                                    if (input === '' || /^[1-9]\d*$/.test(input)) {
                                        setLotInfo(batchData => ({
                                            ...batchData,
                                            amountReceived: input,
                                        }))
                                    }
                                }
                            }}
                            // onChange={(data,value) => handleChange(childProduct.index, 'sku', value)}
                            error={fieldErrors.amountReceived}
                        />
                    </Box>
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:7
                        }}
                    >

                        <Box
                            sx={{
                                width:120,
                                flexShrink:0,
                            }}
                        >
                            <Text light>{t("tht")}</Text>
                        </Box>
                        <ShDateRangePicker
                            explicit
                            singleSelect={true} 
                            startDate={lotInfo.bbDate}
                            shouldHide={lotInfo.bbDate === null}
                            select={(data) => {
                                setLotInfo(lotInfo => ({
                                    ...lotInfo,
                                    bbDate: data[0].formattedStartDate,
                                }))
                            }} 
                            size={32}
                        />
                    </Box>
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:7
                        }}
                    >

                        <Box
                            sx={{
                                width:120,
                                flexShrink:0,
                            }}
                        >
                            <Text light>{t("number")}</Text>
                        </Box>
                        <ShValidatedInput
                            name="number"
                            value={lotInfo.number}
                            onChange={(name,value) => {
                                setLotInfo(lotInfo => ({
                                    ...lotInfo,
                                    number:value
                                }))
                                // const input = value;
                                // console.log("hellowo",input)
                                // if (/^\d*$/.test(input)) {
                                //     if (input === '' || /^[1-9]\d*$/.test(input)) {
                                //         setLotInfo(batchData => ({
                                //             ...batchData,
                                //             amountReceived: input,
                                //         }))
                                //     }
                                // }
                            }}
                            // onChange={(data,value) => handleChange(childProduct.index, 'sku', value)}
                            error={fieldErrors.number}
                        />
                    </Box>
                </Box>
                <Box
                    component="footer"
                    sx={{
                        
                        display:"block",
                        width:1,
                        paddingBottom: isStandAlone ? "32px" : "16px",
                        display:"flex",
                        alignItems:"center",
                        paddingRight:3,
                        zIndex:1058,
                        position:"relative",
                        paddingTop:2,
                        background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        borderBottomLeftRadius:24,
                        borderBottomRightRadius:24,
                        justifyContent:"space-between",
                        "@media screen and (max-width: 47.9375em)" : {
                            paddingRight:0,
                        }
                    }}
                >
                    <Shbutton isCancel={true} className={"always-visible"} onClick={props.handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                    <ButtonGroup version={2}>
                        <Shbutton className={"group-btn"} color={"green"}
                        variant="contained" 
                        isLoading={updateLotLoading}
                        onClick={() => UpdateLotAction()}
                        >{t("save")}</Shbutton>
                    </ButtonGroup>
                </Box>
            </>
            }
        </SHModal>
    )
}

export default MUpdateLot;
